// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { FORMID, TestRunParams } from "./TestRunConstants";
import { Link, useParams } from "react-router-dom";
import { ROUTE_DEFINITIONS, getPath } from "../../routes/routes";
import React, { useEffect, useState } from "react";

import { ContinueButton } from "components/ui/Buttons";
import { getStepReadyEmitter } from "./TestRunStepReadyEmitter";
import { useTestRunConfig } from "./useTestRunConfig";

export interface NextStepButtonProps {
  text?: string;
}

export default (props: NextStepButtonProps) => {
  const { step, testRunUID } = useParams<TestRunParams>();
  const { getTestRunStep, getNextDefaultStep } = useTestRunConfig();
  const currentStepDescription = getTestRunStep(step);
  const [enabled, setEnabled] = useState(
    !(
      currentStepDescription.hasFormContent ||
      currentStepDescription.isBlockingStep
    )
  );

  const nextStep = getNextDefaultStep({
    currentStepName: step,
  });

  const nextPath = nextStep
    ? getPath(ROUTE_DEFINITIONS.PERFORMTEST, {
        params: {
          ":testRunUID": testRunUID,
          ":step": nextStep!,
        },
      })
    : undefined;

  let nextButton = <></>;

  const nextIsDisabled = !enabled;

  if (nextStep !== undefined && nextPath !== undefined) {
    // The next button will get disabled if the current step
    // contains a form.
    nextButton = (
      <ContinueButton
        disabled={nextIsDisabled}
        form={FORMID}
        size="large"
        type="submit"
        {...props}
      />
    );

    if (!(currentStepDescription.hasFormContent || nextIsDisabled)) {
      nextButton = <Link to={nextPath}>{nextButton}</Link>;
    }
  }

  useEffect(() => {
    const emitter = getStepReadyEmitter();
    emitter.on(step, setEnabled);
    return () => {
      emitter.off(step, setEnabled);
    };
  }, [step]);

  return nextButton;
};
